// React Imports
import { ReactElement } from "react";

// Style Imports
import "./take-action-form.scss";

const TakeActionForm: React.FC<any> = ({ children }): ReactElement => {
  return (
    <section className="take-action-component-container flex flex-col py-30">
      <h3>Take action</h3>
      {children}
    </section>
  );
};

export default TakeActionForm;
